(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["philosophy-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('philosophy-banner')) {
    class PhilosophyBanner extends HTMLElement {
      connectedCallback() {
        this.patternLayer = this.querySelector('[data-parallax-layer]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Only hide-then-reveal once JS has actually upgraded the element, so content
        // is never left invisible if this script fails to load or run.
        this.classList.add('js-enabled');

        this.setupReveal();

        if (this.patternLayer && this.patternLayer.dataset.iconSrc) {
          this.setupPattern();
        }

        if (!this.reducedMotion && this.dataset.parallax === 'true' && this.patternLayer) {
          this.setupParallax();
        }
      }

      // Composites the merchant's uploaded icon onto a small <canvas> tile, with the
      // configured gap baked in as transparent margin, then uses that as the CSS mask
      // image. Doing this on a canvas (rather than referencing the icon's URL directly
      // from an SVG used as a CSS mask) avoids browsers refusing to paint external image
      // references inside a mask, which is what caused the pattern to disappear entirely.
      async setupPattern() {
        const layer = this.patternLayer;
        const src = layer.dataset.iconSrc;
        const iconSize = parseInt(layer.dataset.iconSize, 10) || 32;
        const gap = parseInt(layer.dataset.iconGap, 10) || 0;
        const cell = iconSize + gap;

        if (!window.fetch || !document.createElement('canvas').getContext) return;

        try {
          const response = await fetch(src, { mode: 'cors' });

          if (!response.ok) return;

          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);

          const image = new Image();

          await new Promise((resolve, reject) => {
            image.onload = resolve;
            image.onerror = reject;
            image.src = objectUrl;
          });

          const scale = window.devicePixelRatio > 1 ? 2 : 1;
          const canvas = document.createElement('canvas');
          canvas.width = cell * scale;
          canvas.height = cell * scale;

          const ctx = canvas.getContext('2d');
          const offset = (gap / 2) * scale;
          ctx.drawImage(image, offset, offset, iconSize * scale, iconSize * scale);

          URL.revokeObjectURL(objectUrl);

          const dataUrl = canvas.toDataURL('image/png');
          layer.style.setProperty('--philosophy-banner-pattern-icon-url', `url("${dataUrl}")`);
          layer.classList.add('is-ready');
        } catch (error) {
          // Fetch/CORS/decode failure: leave the pattern layer hidden (opacity: 0 from the
          // stylesheet) rather than showing a broken or unmasked block.
        }
      }

      setupReveal() {
        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.add('is-visible');
                observer.disconnect();
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );

        observer.observe(this);
      }

      setupParallax() {
        // A single scroll + rAF driven implementation, used in every browser. An earlier
        // version tried to hand this off to native CSS `animation-timeline: view()` where
        // supported, but that API is unevenly implemented (some browsers accept the syntax
        // without actually driving the animation), which is why the effect could silently
        // do nothing. This version is a few lines longer but always works.
        let ticking = false;
        let isInView = false;

        const getStrength = () =>
          parseFloat(getComputedStyle(this).getPropertyValue('--philosophy-banner-parallax-strength')) || 0.22;

        const update = () => {
          ticking = false;

          const rect = this.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

          // Skip work (but keep listening) once the section is well outside the viewport.
          if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;

          const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
          const clamped = Math.min(Math.max(progress, 0), 1);
          const range = rect.height * getStrength();
          const y = (clamped - 0.5) * range;

          this.patternLayer.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0)`;
        };

        const requestUpdate = () => {
          if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
          }
        };

        const parallaxObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isInView = entry.isIntersecting;

              if (isInView) {
                window.addEventListener('scroll', requestUpdate, { passive: true });
                window.addEventListener('resize', requestUpdate, { passive: true });
                requestUpdate();
              } else {
                window.removeEventListener('scroll', requestUpdate);
                window.removeEventListener('resize', requestUpdate);
              }
            });
          },
          { threshold: 0 }
        );

        parallaxObserver.observe(this);

        // Set an initial position right away instead of waiting for the first scroll or
        // for the observer's first callback, so the pattern isn't sitting at transform: 0
        // if the section is already on screen when the page loads.
        requestUpdate();
      }
    }

    customElements.define('philosophy-banner', PhilosophyBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ribbon-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('ribbon-marquee-texture')) {
    window.customElements.define('ribbon-marquee-texture', class extends HTMLElement {
      connectedCallback() {
        this._offset = 0;
        this._tileWidth = 0;
        this._raf = null;
        this._hovering = false;

        const urlMatch = getComputedStyle(this).backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
        if (!urlMatch) return;

        this._image = new Image();
        this._image.addEventListener('load', () => {
          this._measure();
          this._resizeObserver = new ResizeObserver(() => this._measure());
          this._resizeObserver.observe(this);
          this._intersectionObserver = new IntersectionObserver((entries) => {
            entries[0].isIntersecting ? this._play() : this._stop();
          }, { rootMargin: '100px' });
          this._intersectionObserver.observe(this);
        });
        this._image.src = urlMatch[1];

        if (this.hasAttribute('pause-on-hover')) {
          const ribbon = this.closest('.ribbon-marquee') || this;
          ribbon.addEventListener('pointerenter', () => { this._hovering = true; });
          ribbon.addEventListener('pointerleave', () => { this._hovering = false; });
        }
      }

      disconnectedCallback() {
        this._stop();
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._intersectionObserver) this._intersectionObserver.disconnect();
      }

      _measure() {
        const naturalWidth = this._image.naturalWidth;
        const naturalHeight = this._image.naturalHeight;
        if (!naturalWidth || !naturalHeight) return;

        const sizing = this.getAttribute('sizing');

        if (sizing === 'custom') {
          this._tileWidth = naturalWidth * (parseFloat(this.getAttribute('tile-height')) / naturalHeight);
        } else if (sizing === 'cover') {
          this._tileWidth = naturalWidth * Math.max(this.clientWidth / naturalWidth, this.clientHeight / naturalHeight);
        } else {
          this._tileWidth = naturalWidth * (this.clientHeight / naturalHeight);
        }
      }

      _play() {
        if (this._raf) return;

        // Matches marquee-text's velocity (it travels one scroller width in (1 / speed) * (width / 300) seconds)
        const speed = parseFloat(this.getAttribute('speed')) || 0.3;
        const velocity = 300 * speed * (this.getAttribute('direction') === 'right' ? 1 : -1);
        let lastTime = null;

        const tick = (time) => {
          if (lastTime !== null && !this._hovering && this._tileWidth > 0) {
            this._offset = (this._offset + velocity * (time - lastTime) / 1000) % this._tileWidth;
            this.style.backgroundPositionX = this._offset + 'px';
          }
          lastTime = time;
          this._raf = requestAnimationFrame(tick);
        };

        this._raf = requestAnimationFrame(tick);
      }

      _stop() {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
